import { charsheetAPI, TABLE_USERS } from '../globals.js';
import axios from 'axios';

const getUserData = async ( userName ) => {
                const userTable = TABLE_USERS
                const queryAPI = `${charsheetAPI}?TableName=${userTable}&UserName=${userName}&_=${Date.now()}`;
                const res = await axios.get( queryAPI );
                
                return res.data;
            }

export default getUserData;